// PROD
export const BASE_URL = "http://www.vsbonfim.com.br/api/";
export const URL_BANNERS = "http://www.vsbonfim.com.br/assets/images/";
